import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/product-frontend/product-frontend/lib/auth/protected-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProviderClient"] */ "/home/runner/work/product-frontend/product-frontend/locales/client.ts");
